var jade = require("C:\\Work\\David\\repo\\cartonomy-website\\Cartonomy-Website\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div md-dynamic-height md-border-bottom class=\"toolbar-tabs\"><user-profile></user-profile></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/profile/views/profileView.jade
// module id = 854
// module chunks = 0